// extracted by mini-css-extract-plugin
export default {"container":"SegmentedButtons_container__YVe-3","button":"SegmentedButtons_button__CNRIY","buttonActive":"SegmentedButtons_buttonActive__jlBhk"};